//react
import { useState } from "react";

//component
import { Container, Title, Type } from "./styles";
import { CloseButton } from "../CloseButton";
import ModalElement from "../Modal";

//providers
import { useGuests } from "../../Providers/Guests";
import { GearButton } from "../GearButton";

//interfaces
import { IGuest } from "../../Interfaces";
import GuestsForm from "../FormRegisterGuests";

import { FaEye, FaEyeSlash } from "react-icons/fa";

interface ICardGuestProps {
  infs: IGuest;
  deleteable?: boolean;
  editable?: boolean;
}

export const CardGuest = ({ infs, deleteable, editable }: ICardGuestProps) => {
  const { id, name, email, cpf, birthDate, phone } = infs;

  const { deleteGuest, editGuest } = useGuests();

  const [showModal, setShowModal] = useState<boolean>(false);
  const [expandCard, setExpandCard] = useState<boolean>(false);
  const [valueExpandButton, setValueExpandButton] = useState<boolean>(true);

  const expander = () => {
    if (expandCard) {
      setValueExpandButton(true);
    } else {
      setValueExpandButton(false);
    }
    setExpandCard(!expandCard);
  };
  return (
    <Container>
      <Title>{name}</Title>
      <Type>{email}</Type>
      <Type>CPF: {cpf}</Type>
      <Type>Data de nascimento: {birthDate}</Type>
      <div className="buttons">
        {deleteable && (
          <CloseButton deleteFunctionForId={deleteGuest} id={id} />
        )}
        {editable && <GearButton showModal={() => setShowModal(true)} />}
      </div>
      <Type>
        {expandCard && (
          <div>
            <p>Contatos</p>
            <ul>
              {phone?.map((el, i) => (
                <li key={i}>{el}</li>
              ))}
            </ul>
          </div>
        )}
      </Type>
      <div className="buttonExtend">
        {valueExpandButton ? (
          <button type="button" onClick={expander} className="backExtend">
            <FaEye />
          </button>
        ) : (
          <button type="button" onClick={expander} className="backExtend">
            <FaEyeSlash />
          </button>
        )}
      </div>
      <ModalElement closeModal={() => setShowModal(false)} isOpen={showModal}>
        <GuestsForm handleForm={editGuest} guest={infs} />
      </ModalElement>
    </Container>
  );
};
